import styled from 'styled-components'

export const Table = styled.div`
  width: 100%;
  height: auto;
`
